// Text widths for deciding what fits in a class block, measured on one shared
// canvas in the page's own font. The block's lines follow these, so a class
// name wraps only when it really doesn't fit on one line.

// The fonts of .wc-title and .wc-line in index.css (family from the body).
export const TITLE_FONT = "600 13px";
export const LINE_FONT = "400 12px";

// The time line uses tabular figures, which canvas can't switch on: every
// digit is measured as a 0 (the tabular width) with a little headroom.
const TABULAR_HEADROOM = 1.03;

let context: CanvasRenderingContext2D | null | undefined;
let family = "";
const widths = new Map<string, number>();

// `font` is weight and size ("400 14px"); the family is the body's. Also used
// by the schedule list to fit client names into its Klien column.
export const measure = (text: string, font: string): number => {
  if (context === undefined) {
    context = document.createElement("canvas").getContext("2d");
    family = getComputedStyle(document.body).fontFamily;
  }
  if (!context) return 0;
  const key = `${font}|${text}`;
  const cached = widths.get(key);
  if (cached !== undefined) return cached;
  context.font = `${font} ${family}`;
  const width = context.measureText(text).width;
  // Cache only once the web font is in, so a fallback width never sticks.
  if (document.fonts?.check?.(`${font} ${family}`) !== false) {
    widths.set(key, width);
  }
  return width;
};

export const titleWidth = (text: string) => measure(text, TITLE_FONT);

export const timeWidth = (text: string) =>
  measure(text.replace(/\d/g, "0"), LINE_FONT) * TABULAR_HEADROOM;
